import { useParams, useLocation } from 'react-router-dom'
import { sanitizeRefName } from 'cg/helpers'

const isWorkbenchDocsPath = pathname =>
  pathname.includes('/workbench/') && pathname.includes('/docs/')

export function useIsWorkbenchDocsEmbedded() {
  const { pathname } = useLocation()
  return isWorkbenchDocsPath(pathname)
}

export function useDocumentBasePath() {
  const { username, workspacePath, documentId, repositoryId, branchTagRef } = useParams()
  const { pathname } = useLocation()

  if (isWorkbenchDocsPath(pathname) && repositoryId && branchTagRef && documentId) {
    return `/${username}/${workspacePath}/repository/${repositoryId}/workbench/${sanitizeRefName(branchTagRef)}/docs/${documentId}`
  }

  return `/${username}/${workspacePath}/document/${documentId}`
}

export function useDocumentEditorPath() {
  return `${useDocumentBasePath()}/editor`
}

export function useDocumentEditorSectionPath(versionId, sectionId) {
  return `${useDocumentBasePath()}/editor/${versionId}/${sectionId}`
}

export function useDocumentSettingsPath() {
  return `${useDocumentBasePath()}/settings`
}
